export default {
	name: 'Convention.Registration.Tickets',
	collection: true,
	topLevel: true
}